import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { UI_OPERATION_STATUS_ERROR, userLogout } from '@uncinc/react-drupal-core';

import useClasses from '../../hooks/useClasses';
import Page from '../../containers/Page';
import { IS_REACT_NATIVE } from '../../config/constants';
import { requestReactNativeLogout } from '../../store/actions/UI';
import { Main } from '../../components';

const PageLogout = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageLogout');

  const logoutOperationStatus = useSelector((state) => state.getIn(['ui', 'user', 'operations', 'logout', 'status'], null));

  useEffect(() => {
    // Log out the user.
    if (IS_REACT_NATIVE) {
      // Redirect the user through the native app to get the push token, so it can be cleared from there
      dispatch(requestReactNativeLogout());
    } else {
      dispatch(userLogout());
    }
  }, []);

  return (
    <Page className={buildClass()} title={t('pages.logout.request')}>
      <Main className="col-12 col-lg-8 py-8 py-lg-12">
        <h1 className="asH2">
          {t(`pages.logout.${logoutOperationStatus === UI_OPERATION_STATUS_ERROR ? 'error' : 'request'}`)}
        </h1>
      </Main>
    </Page>
  );
};

export default PageLogout;
